import { useParams } from 'react-router';
import TabItem from '@/components/Tabs/TabItem';
import TabList from '@/components/Tabs/TabList';
import Button from '@/components/UI/Button';
import Card from '@/components/UI/Card/index.tsx';
import ChangeOrderTable from '@/features/ChangeOrder/Summary/Table';
import { mockProgramReports } from '@/features/projects/components/Reports/data';
import { useProject } from '@/hooks/ReactQueryHooks/useProjectQuery';
import { listOfReceipentsColumns, settingsColumns } from './columns';

export function ReportSettings() {
  const { reportId, projectId = '' } = useParams();
  const report = mockProgramReports.find((report) => String(report.id) === reportId);
  const project = useProject({ projectId: Number(projectId) });

  const title = project.data?.data.name ? `${report?.name} for ${project?.data?.data.name}` : `${report?.name}`;

  return (
    <Card title={title} titleElement={<Button btnStyle='btn-primary' label='Save changes'></Button>}>
      <TabList className='pl-4'>
        <TabItem index={0} label='Settings' labelClassName='px-5'>
          <ChangeOrderTable
            tableClassName='!w-full'
            cols={settingsColumns}
            data={[
              {
                id: 1,
                generatedBy: 'Marcus Thompson',
                notes:
                  "This glass office building's reflective façade and clean lines offer a sleek, professional look. Large windows maximize natural light, creating an open, energy-efficient workspace ideal for modern businesses.",
                createdAt: '11/31/2024',
                updatedAt: '11/31/2024',
                lastGeneratedAt: '11/31/2024',
              },
            ]}
          />
        </TabItem>
        <TabItem index={1} label='List of recepients' labelClassName='px-5'>
          <ChangeOrderTable
            tableClassName='!w-full'
            cols={listOfReceipentsColumns}
            data={[
              {
                id: 1,
                name: 'Rolanda Thomas',
                email: 'first.lastname@workplace.com',
                title: 'DSA Client',
                status: 'Invited',
                role: 'Client',
              },
            ]}
          />
        </TabItem>
      </TabList>
    </Card>
  );
}
